var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClass()},[_c('header',{staticClass:"card__header"},[(_vm.title)?_c('div',{staticClass:"card__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("header")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }